/*
  * Invoca internal icon plugin
  */

import "./help_popover";
import $ from "jquery";

$.fn.icon = (function() {
  var userConfig = void 0;
  var config = void 0;

  var knownAttributesMap = {
    className: function className(_className) {
      $(this).addClass(_className);
    },
    tooltip: _applyTooltip,
    action: function action(_action) {
      $(this).attr('data-action', _action).data('action', _action);
    }
  };

  var statusIcons = {
    live: { icon: "lens", className: "text-success" },
    success: { icon: "check", className: "text-success" },
    error: { icon: "error", className: "text-danger" },
    warning: { icon: "warning", className: "text-warning" },
    pending: { icon: "lens", className: "text-warning" },
    inactive: { icon: "lens", className: "text-muted" },
    paused: { icon: "pause_circle_filled", className: "text-muted" }
  };

  return function(options) {
    userConfig = typeof options === "string" ? { icon: options } : options;
    var singleIcon = _targetIsAnIcon.call(this, userConfig);

    if (singleIcon) {
      return _updateThisIcon.call(this);
    } else {
      _updateAllIcons.call(this);
      return this;
    }
  };

  // Private

  function _updateAllIcons() {
    var target = $(this);
    var iconSelector = "[data-icon]:not(.material-icons), [data-status-icon]:not(.material-icons)";
    var filteredElements = target.filter(iconSelector);
    var targetElements = filteredElements.length ? filteredElements : target.find(iconSelector);

    targetElements.each(_updateThisIcon);
  }

  function _updateThisIcon() {
    var target = $(this);
    config = _getAllConfigs(target);

    target.addClass("material-icons").text(config.icon);
    $.each(knownAttributesMap, function(attr, action) {
      if (config[attr]) {
        if (action.constructor === Function) {
          action.call(this, config[attr]);
        } else {
          throw new Error('Action for ' + attr + ' in knownAttributesMap must be a function, instead got ' + typeof action);
        }
      }
    }.bind(this));

    return _transformWithMessageIfNeeded.call(this);
  }

  function _transformWithMessageIfNeeded() {
    if (config.message) {
      var icon = $(this).clone().addClass('icon--status');
      var parent = $('<span>');
      var message = _buildMessageEl();

      parent.append(icon).append(message);
      $(this).replaceWith(parent);

      return parent;
    } else {
      return this;
    }
  }

  function _getAllConfigs(target) {
    var dataset          = target[0].dataset;
    var currentConfig    = $.extend({}, dataset, userConfig);
    var statusIconConfig = _statusIconConfig(currentConfig);
    var fullIconConfig   = $.extend({}, currentConfig, statusIconConfig);
    var textConfig       = _buildTextOptionsFromTarget(target, fullIconConfig);

    return $.extend({}, fullIconConfig, textConfig);
  }

  function _statusIconConfig(currentConfig) {
    if (currentConfig.statusIcon) {
      // special case to allow additional classes from user config
      var config = statusIcons[currentConfig.statusIcon];
      if (config && currentConfig.className) {
        config.className = config.className + ' ' + currentConfig.className;
      }
      return config;
    } else {
      return {};
    }
  }

  function _buildTextOptionsFromTarget(target, config) {
    if (target.text()) {
      config.message = target.text();
    }

    switch (typeof config.message) {
    case "string":
      return {
        message: {
          text: config.message, action: null
        }
      };

    case "object":
      return config.message;

    default:
      return {};
    }
  }

  function _applyTooltip(text) {
    var defaultConfig = {
      trigger: 'hover',
      placement: config.tooltipPlacement || 'top',
      title: text
    };

    var tooltipType = config.tooltipType === "popover" ? {} : { toggle: "tooltip" };
    var helpConfig = $.extend({}, defaultConfig, tooltipType);

    $(this).helpPopover(helpConfig);
  }

  function _targetIsAnIcon() {
    var userConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var target = $(this);

    return target.length === 1 && (userConfig.icon || target.data("icon") || userConfig.statusIcon || target.data("status-icon"));
  }

  function _buildMessageEl() {
    var span = $("<span>").text(config.message.text);
    if (config.message.action) {
      span.attr('data-action', config.message.action).data('action', config.message.action);
    }

    return span;
  }
}());
